module.exports = __webpack_public_path__ + "static/media/gamesWon_5000_10000.a35348fc.png";